import { useHasPermission } from "@/store/authStore";
import AgentPulseController from "@/modules/agentPulse/controllers/AgentPulseController";
import AccessRestricted from "@/components/AccessRestricted";
import { Permission } from "@forgepoint/shared";

/**
 * Agent Pulse page, gated on the agentpulse.view permission. Users without it
 * see an access denied message.
 */
export default function AgentPulsePage() {
  const canViewAgentPulse = useHasPermission(Permission.AGENTPULSE_VIEW);

  if (!canViewAgentPulse) {
    return (
      <AccessRestricted
        breadcrumbs={[{ label: "Agent Pulse", current: true }]}
      />
    );
  }

  return <AgentPulseController />;
}
